<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex'
export default {
    setup(){

        const store = useStore();
        const data = computed(()=>store.getters.poster)

        return {data};

    }
}
</script>

<template>
  <div class="title">Thematic Poster</div>
  <div class="main">
    <div class="poster" v-for="item in data" :key="item.name">
        <img :src=item.picture :alt=item.name class="img">
    </div>
  </div>
</template>


<style lang="scss" scoped>
.title{
    width: 10%;
    text-align: center;
    font-size: 30px;
    color: #fff;
    font-weight:bold;
    margin: 1% 1% 1% 1%;
    background-color: #61d8cd;
    border-radius: 15px;
}
.main{
    display:flex;
    flex-wrap: wrap;
    >.poster{
        width: 31.3%;
        text-align: center;
        margin: 1% 1% 1% 1%;
        border-radius: 15px;
        >.img{
            width:80%;
           
        }
    }
}
</style>